// extracted by mini-css-extract-plugin
module.exports = {"layout_2QJBLP":"layout_2QJBLP","components_mOEPwo":"components_mOEPwo"};